import { platform } from '@/utils/platform';

export async function initCapacitorPlugins() {
  if (!platform.isNative) return;

  const { StatusBar, Style } = await import('@capacitor/status-bar');
  await StatusBar.setStyle({ style: Style.Light });
  if (platform.isAndroid) {
    await StatusBar.setBackgroundColor({ color: '#ffffff' });
  }
}
